import { cn } from "@/lib/utils";

export function KpiCard({ label, value, delta, hint, icon: Icon, accent, testId, className }) {
  const deltaPositive = typeof delta === "number" && delta > 0;
  const deltaNegative = typeof delta === "number" && delta < 0;
  return (
    <div
      data-testid={testId}
      className={cn(
        "relative border border-border bg-card rounded-lg p-5 flex flex-col justify-between h-full transition-transform duration-200 hover:-translate-y-0.5",
        className,
      )}
    >
      <div className="flex items-start justify-between">
        <div className="text-[10px] uppercase tracking-[0.18em] font-mono text-muted-foreground">
          {label}
        </div>
        {Icon ? (
          <div
            className="w-8 h-8 rounded-md grid place-items-center bg-secondary text-foreground"
            style={accent ? { color: accent } : undefined}
          >
            <Icon className="h-4 w-4" />
          </div>
        ) : null}
      </div>
      <div className="mt-6">
        <div className="font-mono text-3xl sm:text-4xl tracking-tight tabular">{value}</div>
        <div className="mt-2 flex items-center gap-2 text-xs">
          {typeof delta === "number" && (
            <span
              className={cn(
                "font-mono tabular",
                deltaPositive && "text-[hsl(var(--chart-3))]",
                deltaNegative && "text-destructive",
                !deltaPositive && !deltaNegative && "text-muted-foreground",
              )}
            >
              {deltaPositive ? "▲" : deltaNegative ? "▼" : "•"} {Math.abs(delta)}
            </span>
          )}
          {hint ? <span className="text-muted-foreground">{hint}</span> : null}
        </div>
      </div>
    </div>
  );
}
